export { APP_TITLE } from '@shared/socialDocumentMeta';

export const APP_TITLE_SHORT = '裁判分析';
export const APP_LOGO_FALLBACK = '/icon-192.png';
